"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.getCurrentYear=e=>e?new Date(e).getFullYear():(new Date).getFullYear();
//# sourceMappingURL=year.js.map
